import React, { useEffect, useState } from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "./DayTimeLine.module.css";
import {
  range,
  getDuration,
  getWorkSlotActivityPercentage,
  changeTimzone,
} from "../../helpers/stubs";
import { useSelector, useDispatch } from "react-redux";
import { getActivityForDay } from "../../Slices/candidateSlice";
import moment from "moment";
import momentTz from "moment-timezone";

function DayTimeLine() {
  // #region Store Listeners
  const dispatch = useDispatch();
  const { selectedDay, workSlots } = useSelector(
    (state) => state.candidateSlice
  );
  const {
    sessionUser,
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  // #endregion

  // #region Effects
  const candidateId = sessionUser.candidates[0]._id;
  useEffect(() => {
    // Backend expects UTC timestamp where UTC date matches the intended date
    // Extract date from selectedDay in timezone, then create UTC timestamp with same date
    const selectedDayInTimezone = momentTz(selectedDay).tz(timezone);
    const year = selectedDayInTimezone.year();
    const month = selectedDayInTimezone.month();
    const date = selectedDayInTimezone.date();
    // Create UTC timestamp with same date components at noon UTC
    const normalizedDay = momentTz.utc([year, month, date, 12, 0, 0]).toISOString();
    const payload = {
      candidateId,
      day: normalizedDay,
    };
    dispatch(getActivityForDay(payload));
  }, [selectedDay, timezone, candidateId, dispatch]);
  // #endregion
 console.log("dayTimeline", selectedDay, "timezone", timezone)

  const emptyActivity = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0,
  ];

  const dummyFill = [...range(1, 47)].map(() => 1);

  const activty2 = [
    0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    0, 0, 0, 0, 0,
  ];

  const getDayMap = (workSlots) => {
    return workSlots
      .map((item) => {
        return {
          ...item,
          slotFrom: changeTimzone(item.slotFrom, timezone),
          slotTo: changeTimzone(item.slotTo, timezone),
        };
      })
      .reduce(
        (acc, slot) => {
          const slotFromM = moment(slot.slotFrom);
          const slotToM = moment(slot.slotTo);
          const slotFromMinute = slotFromM.get("minute");
          const slotStartHour = slotFromM.get("hour");
          const dayMapPoint = slotStartHour * 59 + slotFromMinute;
          const slotDuration = getDuration(slotFromM, slotToM);
          let filler = "none";
          let activityPercentage = 0;
          if (slot.slotType !== "tracker") {
            filler = "offline";
          } else {
            activityPercentage = getWorkSlotActivityPercentage(slot);
            if (activityPercentage > 60) {
              filler = "green";
            } else if (activityPercentage > 40) {
              filler = "yellow";
            } else if (activityPercentage > 20) {
              filler = "red";
            } else {
              filler = "worst";
            }
          }
          const tempData = [...range(1, slotDuration)].map(() => ({
            filler,
            id: slot._id,
            activityPercentage,
          }));
          acc.splice(dayMapPoint, slotDuration, ...tempData);
          return acc;
        },
        [...range(1, 24 * 60)].map(() => 0)
      );
  };

  const getActivity = (hour) => {
    if (hourMap.has(hour)) {
      return emptyActivity;
    } else {
      return hourMap.get(hour);
    }
  };

  const getHourMap = (dayMap) => {
    return [...range(0, 23)].reduce((acc, hour, index) => {
      const startHour = index * 59;
      const endHour = startHour + 59;
      acc.set(hour, dayMap.slice(startHour, endHour));
      return acc;
    }, new Map());
  };

  const getActivityLine = (activity) => {
    if (activity === 0) {
      return `${styles.overlay_empty}`;
    }
    if (activity.filler === "red") {
      return `${styles.overlay_red}`;
    }
    if (activity.filler === "green") {
      return `${styles.overlay_green}`;
    }
    if (activity.filler === "yellow") {
      return `${styles.overlay_yellow}`;
    }
    if (activity.filler === "offline") {
      return `${styles.overlay_offline}`;
    }
    if (activity.filler === "worst") {
      return `${styles.overlay_worst}`;
    }

    return `${styles.overlay_line}`;
  };

  const getTimeRep = (hour) => {
    let prefix = "";
    let suffix = "";
    if (hour < 12) {
      suffix = "am";
      if (hour === 0) {
        prefix = "12";
      } else {
        prefix = hour;
      }
    } else {
      suffix = "pm";
      if (hour === 12) {
        prefix = "12";
      } else {
        prefix = hour - 12;
      }
    }
    return prefix + suffix;
  };

  const dayMap = getDayMap(workSlots);
  const hourMap = getHourMap(dayMap);

  return (
    <Row className="p-0">
      {[...range(0, 23)].map((item) => (
        <Col className={`p-0 border border-secondary  ${styles.small_text}`}>
          <div
            className={`${styles.container} ${styles.cell_width} ${styles.cell_height} `}
          >
            <div className={`${styles.box} `}>
              <div className="">
                <span>{getTimeRep(item)}</span>
              </div>
            </div>
            {hourMap
              .get(item)
              .slice(0, 47)
              .map((activity, index) => {
                const activityline = getActivityLine(activity);
                const id = activity.id ? activity.id : "0";

                if (activity.filler === "offline") {
                  return (
                    <>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="button-tooltip-2">
                            {`Offline Slot`}
                          </Tooltip>
                        }
                      >
                        {({ ref, ...triggerHandler }) => {
                          return (
                            <>
                              <div {...triggerHandler}>
                                <div
                                  ref={ref}
                                  onClick={() => {
                                    window.location.hash = `#${id}`;
                                  }}
                                  style={{ left: index }}
                                  className={`${styles.box} ${activityline}`}
                                />
                              </div>
                            </>
                          );
                        }}
                      </OverlayTrigger>
                    </>
                  );
                }

                if (activity.activityPercentage === undefined) {
                  return (
                    <div
                      onClick={() => {
                        window.location.hash = `#${id}`;
                      }}
                      style={{ left: index }}
                      className={`${styles.box} ${activityline}`}
                    />
                  );
                }
                return (
                  <>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="button-tooltip-2">
                          {`Activity Percentage ${activity.activityPercentage}`}
                        </Tooltip>
                      }
                    >
                      {({ ref, ...triggerHandler }) => {
                        return (
                          <>
                            <div {...triggerHandler}>
                              <div
                                ref={ref}
                                onClick={() => {
                                  window.location.hash = `#${id}`;
                                }}
                                style={{ left: index }}
                                className={`${styles.box} ${activityline}`}
                              />
                            </div>
                          </>
                        );
                      }}
                    </OverlayTrigger>
                  </>
                );
              })}
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default DayTimeLine;
